document.addEventListener("DOMContentLoaded", function () {
	const video = document.getElementById("custom-video");
	const playPauseBtn = document.getElementById("play-pause-btn");

	const playIcon = `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM29.7655 18.7127C30.7395 19.2948 30.7395 20.7058 29.7655 21.2879L17.4043 28.6755C15.9045 29.5718 14 28.4913 14 26.7441V13.2568C14 11.5097 15.9045 10.4292 17.4042 11.3254L29.7655 18.7127Z" fill="black" fill-opacity="0.4"/></svg>`;
	const pauseIcon = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 48" width="36" height="36"><path stroke="#5b5f9b" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M16 10v28m16-28v28"/></svg>`;
	
	if(playPauseBtn){
		playPauseBtn.innerHTML = playIcon; // Set initial icon
	
		playPauseBtn.addEventListener("click", function () {
			if (video.paused) {
				video.play();
				playPauseBtn.innerHTML = pauseIcon;
			} else {
				video.pause();
				playPauseBtn.innerHTML = playIcon;
			}
		});
	}
});